module.exports = __webpack_public_path__ + "static/media/Train.ccb3dfc1.ogg";